import i18next from 'i18next'
import {inject, injectable} from 'inversify'
import {action, makeObservable, observable, runInAction} from 'mobx'
import {cancelLink} from '@/api'
import {openErrorNotification, openSuccessNotification} from '@/utils'
import {PayByLinkStoreSymbol} from '@/pages/PayByLink'
import {IPayByLinkStore} from '@/pages/PayByLink/IPayByLinkStore'
@injectable()
export class CancelPaymentLinkStore {
    private readonly _payByLinkStore: IPayByLinkStore

    constructor(@inject(PayByLinkStoreSymbol) payByLinkStore: IPayByLinkStore) {
        this._payByLinkStore = payByLinkStore

        makeObservable(this, {
            isLoading: observable,
            cancelPaymentLink: action.bound
        })
    }

    public isLoading = false

    public async cancelPaymentLink(id) {
        this.isLoading = true
        try {
            const {error} = await cancelLink(id)

            runInAction(() => {
                if (error) {
                    return openErrorNotification(error.message)
                }

                this._payByLinkStore.loadPaymentLinks()

                return openSuccessNotification(i18next.t('pay-by-link.linkDeactivated'))
            })
        } catch (error) {
            return openErrorNotification(i18next.t('globals:errors.general'))
        } finally {
            this.isLoading = false
        }
    }
}
